var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-container"},[_c('table-policies',{ref:_vm.tableRef,attrs:{"isTableInModal":true,"filterOn":{ byRelations: ['byMandateCode'] },"fields":_vm.fields,"repository":_vm.repository,"resource":_vm.resource,"filterName":_vm.filterName,"onlyActions":['infomodal'],"noInnerWidth":"","noInputPaginator":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }